import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { ArrowRight } from "lucide-react";

/**
 * Horizontal marquee ticker of latest transfers. Silent when empty.
 */
export default function TransferTicker() {
  const [rows, setRows] = useState([]);

  useEffect(() => {
    api.get("/transfers/ticker").then((r) => setRows(r.data || [])).catch(() => setRows([]));
  }, []);

  if (!rows.length) return null;

  return (
    <div className="border border-[#232330] bg-[#101015] overflow-hidden" data-testid="transfer-ticker">
      <div className="flex items-center">
        <div className="shrink-0 bg-[#F4D03F] text-black px-4 py-2 text-[10px] font-mono uppercase tracking-widest font-black">
          / TRANSFERS
        </div>
        <div className="flex-1 overflow-hidden relative">
          <div className="flex gap-8 py-2 px-4 animate-[ticker_40s_linear_infinite] whitespace-nowrap">
            {[...rows, ...rows].map((t, i) => (
              <div key={i} className="text-xs font-mono uppercase tracking-widest text-gray-300 flex items-center gap-2">
                <span className="font-bold" style={{ color: t.from_team?.logo_color || "#666" }}>{t.from_team?.tag || "FA"}</span>
                <ArrowRight className="w-3 h-3 text-gray-500" />
                <span className="font-bold" style={{ color: t.to_team?.logo_color || "#666" }}>{t.to_team?.tag || "FA"}</span>
                <span className="text-white">·</span>
                <span className="text-white">{t.player_handle}</span>
              </div>
            ))}
          </div>
        </div>
      </div>
      <style>{`@keyframes ticker { 0% { transform: translateX(0); } 100% { transform: translateX(-50%); } }`}</style>
    </div>
  );
}
